var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0013 8.83398C2.46154 8.83398 2.83463 8.46089 2.83463 8.00065C2.83463 7.54041 2.46154 7.16732 2.0013 7.16732C1.54106 7.16732 1.16797 7.54041 1.16797 8.00065C1.16797 8.46089 1.54106 8.83398 2.0013 8.83398Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0013 3.00065C2.46154 3.00065 2.83463 2.62755 2.83463 2.16732C2.83463 1.70708 2.46154 1.33398 2.0013 1.33398C1.54106 1.33398 1.16797 1.70708 1.16797 2.16732C1.16797 2.62755 1.54106 3.00065 2.0013 3.00065Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0013 14.6673C2.46154 14.6673 2.83463 14.2942 2.83463 13.834C2.83463 13.3737 2.46154 13.0007 2.0013 13.0007C1.54106 13.0007 1.16797 13.3737 1.16797 13.834C1.16797 14.2942 1.54106 14.6673 2.0013 14.6673Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotVertical);
export default __webpack_public_path__ + "static/media/three-dot-vertical.a8d9f75444b409293c8c36db6ec2d689.svg";
export { ForwardRef as ReactComponent };